import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import ColorSwatch from './ColorSwatch';

/**
 * ColorPalette Component
 * Displays a grid of color swatches
 */
const ColorPalette = ({ colors, title, size = 50 }) => {
  if (!colors || colors.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      {title && (
        <Typography
          variant="subtitle2"
          sx={{
            mb: 1.5,
            fontWeight: 600,
            color: 'text.primary'
          }}
        >
          {title}
        </Typography>
      )}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: `repeat(auto-fill, minmax(${size + 20}px, 1fr))`,
          gap: 2,
          p: 2,
          backgroundColor: '#f5f5f5',
          borderRadius: 1,
          border: '1px solid rgba(0, 0, 0, 0.08)'
        }}
      >
        {colors.map((color, index) => (
          <ColorSwatch
            key={`${color.hex}-${index}`}
            color={color}
            size={size}
            showLabel={true}
          />
        ))}
      </Box>
    </Box>
  );
};

export default ColorPalette;
